import React from 'react';
import FormDataImgUploader from './components/FormDataImgUploader/FormDataImgUploader';
import InputFields from './components/InputFields/InputFields';
import classNames from 'classnames';
import style from './EditForm.module.scss';

interface IEditForm {
	isVisible: boolean;
}

const EditForm: React.FC<IEditForm> = ({ isVisible }) => {
	const containerClasses = classNames(style.container, { [style.visible]: isVisible });

	return (
		<div className={containerClasses} data-test="CreationForm">
			<FormDataImgUploader />
			<InputFields />
		</div>
	);
};

export default EditForm;
